import React from 'react';
import { cn } from './cn';
import { Icon } from './base/Icon';

export interface Crumb {
  label: string;
  href?: string;
}

/** Breadcrumb — รายการสุดท้ายคือหน้าปัจจุบัน ไม่เป็นลิงก์ */
export const Breadcrumb: React.FC<{ items: Crumb[]; className?: string }> = ({ items, className }) => (
  <nav aria-label="ตำแหน่งปัจจุบัน" className={cn('font-[family-name:var(--font-thai)]', className)}>
    <ol className="flex flex-wrap items-center gap-[var(--space-1)] text-[length:var(--text-table)] leading-[var(--leading-table)]">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <li key={`${c.label}-${i}`} className="flex items-center gap-[var(--space-1)]">
            {i > 0 && <Icon name="chevron_right" size={16} className="text-[var(--ink-400)]" />}
            {last || !c.href ? (
              <span aria-current={last ? 'page' : undefined} className="font-[var(--weight-medium)] text-[var(--ink-900)]">
                {c.label}
              </span>
            ) : (
              <a
                href={c.href}
                className="rounded-[var(--radius-sm)] text-[var(--blue-700)] underline underline-offset-2 hover:text-[var(--blue-800)] outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--focus-ring-color)] focus-visible:ring-offset-2"
              >
                {c.label}
              </a>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
